import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useStyles } from './AbortedMatchStatus.styles';

export const AbortedMatchStatus: FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>ABORTED</Typography>
      <Typography className={classes.description}>Did not receive any player results.</Typography>
    </Box>
  );
};
